import TermsOfService from '../containers/TermsOfService';
export default TermsOfService;
